module.exports = __webpack_public_path__ + "static/media/yinhang.5473a3f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/yinhang.png
// module id = 2182
// module chunks = 0